import { useEffect, useState, useRef } from "react";
import pinkClouds from "../assets/images/pink-clouds-divider.png";


import yellowWhiteGradient from "../assets/images/yellow-white-gradient.svg";
import boxerGuy from "../assets/images/boxer-guy.png";
import barefootGuy from "../assets/images/barefoot-guy.png";
import dressGirl from "../assets/images/dress-girl.png";
import layingGirl from "../assets/images/laying-girl.png";
import suitGuy from "../assets/images/suit-guy.png";
import urbanGuy from "../assets/images/urban-guy.png";

import blueGreenProdInfo from "../assets/images/blue-green-eg-prod.png";
import yellowProdInfo from "../assets/images/yellow-eg-prod.png";
import blueProdInfo from "../assets/images/blue-eg-prod.png";
import redProdInfo from "../assets/images/red-eg-prod.png";
import gardenFooter from "../assets/images/garden-footer.png";
import infoCloud from "../assets/images/info-cloud.png";

export default function ProductInfo() {
  const productImages = [
    { src: blueGreenProdInfo, alt: "Blue Green Vape" },
    { src: yellowProdInfo, alt: "Yellow Vape" },
    { src: blueProdInfo, alt: "Blue Vape" },
    { src: redProdInfo, alt: "Red Vape" },
  ];

  const characterImages = [
    { src: barefootGuy, alt: "Barefoot Guy" },
    { src: dressGirl, alt: "Dress Girl" },
    { src: layingGirl, alt: "Laying Girl" },
    { src: suitGuy, alt: "Suit Guy" },
    { src: urbanGuy, alt: "Urban Guy" },
  ];

  const [rainingProducts, setRainingProducts] = useState([]);
  const [floatingCharacters, setFloatingCharacters] = useState([]);
  const containerRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Scroll observer → derive progress (0–1)
  useEffect(() => {
    const onScroll = () => {
      const el = containerRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const totalHeight = rect.height - window.innerHeight;
      const progress = Math.min(Math.max(-rect.top / totalHeight, 0), 1);
      setScrollProgress(progress);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // --- Raining Products ---
  useEffect(() => {
    const productInterval = setInterval(() => {
      const newProducts = Array.from({ length: 2 }).map(() => {
        const base = productImages[Math.floor(Math.random() * productImages.length)];
        return {
          ...base,
          id: Date.now() + "-" + Math.random(),
          x: `${Math.random() * 95}vw`,
          duration: 30 + Math.random() * 20, // fall speed
          size: 0.5 + Math.random() * 1.2,
          zIndex: Math.floor(Math.random() * 10) + 1,
          opacity: 0.6 + Math.random() * 0.4,
        };
      });
      setRainingProducts((prev) => [...prev, ...newProducts].slice(-60));
    }, 500); // twice per second
    return () => clearInterval(productInterval);
  }, []);

  // --- Floating Characters ---
  useEffect(() => {
    let lastChar = null;
    const charInterval = setInterval(() => {
      let choice;
      do {
        choice = characterImages[Math.floor(Math.random() * characterImages.length)];
      } while (choice.alt === lastChar); // reject consecutive duplicate
      lastChar = choice.alt;

      const id = Date.now() + "-char";
      const size = 5 + Math.random() * 10;
      const zIndex = Math.floor(Math.random() * 8) + 1;
      const opacity = Math.min(1, 0.3 + size / 12);

      setFloatingCharacters((prev) => {
        const updated = [
          ...prev,
          {
            ...choice,
            id,
            x: `${Math.random() * 90}vw`,
            duration: 150 + Math.random() * 160,
            size,
            zIndex,
            opacity,
          },
        ];
        return updated.length > 25 ? updated.slice(-25) : updated;
      });
    }, 2000); // every 2 seconds
    return () => clearInterval(charInterval);
  }, []);

  return (
    <div
      ref={containerRef}
      className="prod-info-container"
    >
      <div
              className="cloud-divider bottom"
              style={{
                backgroundImage: `url(${pinkClouds})`,
                position: "absolute",
                top: -150,
                zIndex: 99,
                height: "13%"
              }}
            />
      <div
        className="zoom-wrapper"
        style={{
          transform: `scale(${1 - scrollProgress * 0.75})`, // shrink scene as scrolls
        }}
      >
        {/* Derived Terpenes */}
        <div className="info-cloud-wrapper derived-terpenes">
          <img src={infoCloud} alt="Info Cloud" className="info-cloud-img" />
          <h2>100% Cannabis <br /> Derived Terpenes</h2>
        </div>

        {/* No Cutting Agents */}
        <div className="info-cloud-wrapper no-cutting-agents">
          <img src={infoCloud} alt="Info Cloud" className="info-cloud-img" />
          <h2>No Cutting Agents</h2>
        </div>

        {/* Premium Distillate */}
        <div className="info-cloud-wrapper premium-distillate">
          <img src={infoCloud} alt="Info Cloud" className="info-cloud-img" />
          <h2>Premium Distillate</h2>
        </div>

        {/* High Potency */}
        <div className="info-cloud-wrapper high-potency">
          <img src={infoCloud} alt="Info Cloud" className="info-cloud-img" />
          <h2>High Potency</h2>
        </div>


        {/* Products raining */}
        {rainingProducts.map((item) => (
          <img
            key={item.id}
            src={item.src}
            alt={item.alt}
            className="raining-product-story"
            style={{
              left: item.x,
              transform: `scale(${item.size})`,
              width: `${item.size}vw`,
              maxWidth: "120px",
              zIndex: item.zIndex,
              opacity: item.opacity,
              animationDuration: `${item.duration}s`, // 👈 each has its own duration
            }}
          />

        ))}

        {/* Floating characters */}
        {floatingCharacters.map((char) => (
          <img
            key={char.id}
            src={char.src}
            alt={char.alt}
            className="floating-character"
            style={{
              left: char.x,
              width: `${char.size}%`,
              zIndex: char.zIndex,
              opacity: char.opacity,
              animationDuration: `${char.duration}s`,
            }}
          />
        ))}
      </div>

      {/* Footer */}
      <img
        src={gardenFooter}
        alt="Garden Footer"
        className="garden-footer"

      />

    </div>
  );
}
